import React from "react";
import { cn } from "@/lib/utils";

interface GradientTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  className?: string;
  children: React.ReactNode;
  from?: string;
  to?: string;
  via?: string;
}

function GradientText({
  className,
  children,
  from = "from-blue-500",
  to = "to-blue-200",
  via,
  ...props
}: GradientTextProps) {
  const gradientClasses = via 
    ? `bg-gradient-to-r ${from} ${via} ${to}`
    : `bg-gradient-to-r ${from} ${to}`;

  return (
    <span
      className={cn(
        gradientClasses,
        "bg-clip-text text-transparent font-bold",
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}

export { GradientText }